import {AfterViewInit, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {EsBsModalService} from "../../services/bsModalService/bs-modal.service";
import {filter} from "rxjs/operators";
import {Item} from '../../models/Item';
import {MeasurementService} from '../../services/measurementAdapter/measurement.service';
import {STATIC_FIELD_IN_DATE, STATIC_FIELD_OUT_DATE} from '../../interfaces/constants';
import {GlobalEventsService} from '../../services/global-events.service';
import { isViewMode } from 'src/configs/view_only';

@Component({
  selector: 'app-vertex-modal',
  templateUrl: './vertex-modal.component.html',
  styleUrls: ['./vertex-modal.component.scss']
})
export class VertexModalComponent implements OnInit, AfterViewInit {

  Yiit = Yiit;
  private _currentItem:Item;
  private _currentPoints;
  public vertexInputNames: string[];
  private settings: any = {};
  private hasMeasurement: boolean;
  private _isViewMode = isViewMode;

  private inputsCharacterLimit:{[key: string]: number} = {
    __vm_name : 250,
    __vm_vendor_zone: 250,
    __vm_furniture: 1000
  };

  private numberInputs:any[] = ['people_per_car'];
  private validateInOutDates(item: Item, name: string, newValue: string): { value: string, error: boolean, message: string } {

    const getValue = (inputName: string) => item.config.getInputs()[inputName] ? item.config.getInputs()[inputName].date : null;
    let inValue = getValue(STATIC_FIELD_IN_DATE);
    let outValue = getValue(STATIC_FIELD_OUT_DATE);
    const inTitle = item.config.getInputs()[STATIC_FIELD_IN_DATE].label;
    const outTitle = item.config.getInputs()[STATIC_FIELD_OUT_DATE].label;

    if (name === STATIC_FIELD_OUT_DATE && inValue) {
      const newOutVal = new Date(newValue).getTime();
      inValue = new Date(inValue).getTime();
      if (newOutVal < inValue) {
        return {
          value: outValue,
          error: true,
          message: `${outTitle} cannot be before ${inTitle}`
        };
      }
    }

    if (name === STATIC_FIELD_IN_DATE && outValue) {
      const newInVal = new Date(newValue).getTime();
      outValue = new Date(outValue).getTime();
      if (newInVal > outValue) {
        return {
          value: inValue,
          error: true,
          message: `${inTitle} cannot be after ${outTitle}`};
      }
    }

    return {value: newValue, error: false, message: null};
  }

  constructor(private bs: EsBsModalService, private cd: ChangeDetectorRef, private measurement: MeasurementService, private globalEvents: GlobalEventsService) { }

  ngOnInit() {
    this.bs.modalUpdated.pipe(filter((event)=>{return this.bs.currentModal == '#es-vertex-modal'})).subscribe((event)=>{
      if (event == 'opened'){
        let config:{item: Item} = this.bs.getCurrentConfig();
        if (config.item){
          this._currentItem = config.item;
          this._currentPoints = this._currentItem.config.getObjectConfig().getPositions();
          this.initVariablesForItem();
          this.setItemSettingsNames();
          this.initInputValues();
          this.cd.detectChanges();
        }
      }
      if (event == 'closed'){
        this._currentItem = null;
        this._currentPoints = null;
        this.settings = {};
        this.vertexInputNames = [];
        this.cd.detectChanges();
      }
    })
  }

  get isViewMode():boolean {
    // return this._isViewMode ? this._isViewMode : (this._currentItem) ? !this._currentItem.config.canEdit : this._isViewMode;
    return this._isViewMode ? this._isViewMode : this._isViewMode;
  }

  private initVariablesForItem(){
    this.hasMeasurement = this.measurement.hasMeasurement(this._currentItem);
  }

  ngAfterViewInit() {
    this.cd.detectChanges();
  }

  getPoints(){
    return this._currentPoints;
  }

  getPointName(index){
    return Yiit.t(`Point ${index+1}`);
  }

  isContainCalculation(){
    return false;
    // setting.value.hasOwnProperty('calculation')
  }

  getSettingLabel(name) {
    let setting = this.settings[name];
    if (this.hasMeasurement && setting.hasOwnProperty('label')) {
      return this.Yiit.t(this.measurement.getMeasurementLabel(this._currentItem, this._currentItem.config.getInputByName(name)));
    }
    return this.Yiit.t(this._currentItem.config.getInputProp(name, 'label'));
  }

  isSettingHasMeasurement(name): boolean {
    let setting = this.settings[name];
    return this.hasMeasurement && setting.hasOwnProperty('label');
  }


  validateItemParam(index, name, prop, event){
    // character limit
    let item = this._currentItem;
    if (this.inputsCharacterLimit.hasOwnProperty(name)) {
      const count = event.target.value.length;
      if (count > this.inputsCharacterLimit[name]) {
        event.target.value = event.target.value.substring(0, this.inputsCharacterLimit[name]);
      }
    }

    let result = (typeof event === 'string') ? event : event.target.value;
    const NaN = (item.config.getInputProp(name, 'isNaN'));
    const allowNegative = (item.config.getInputProp(name, 'allow_negative'));

    // check for number and negative number
    if (!NaN && !isNaN(parseFloat(result)) && (parseFloat(result).toString()) === result.trim()) {
      result = parseFloat(result);
      if (!allowNegative && result < 0) {
        result = 0;
      }
    }

    if (this.numberInputs.includes(name)) {
      result = this.setWrongNumberToZero(result, allowNegative);
      event.target.value = result;
    }

    if (this.measurement.hasMeasurement(item, name) && prop.toLowerCase() === 'value') {
      if (result.toString().indexOf(',') >= 0) {
        result = result.replace(/,/, '.');
      }

      result = this.measurement.getUnconvertedInputVal(item, item.config.getInputByName(name), result);

      if (isNaN(result) || result === '') {
        result = '0';
      }
    }

    if ([STATIC_FIELD_OUT_DATE, STATIC_FIELD_IN_DATE].includes(name)) {
      const {value, error, message} = this.validateInOutDates(item, name, event.target.value);
      result = value;
      if (error) {
        this.globalEvents.ToastNotificationEvent.emit({
          message,
          title: 'In/Out date error',
          classes: ['error']
        });
        event.target.value = value;
        this.cd.detectChanges();
      }
    }



    let propertyVal = item.config.getInputProp(name, prop)
    let resultArr = Array.isArray(propertyVal) ? propertyVal.slice() : propertyVal;
    if (!Array.isArray(resultArr)){
      resultArr = new Array(this.getPoints().length).fill(propertyVal, 0, this.getPoints().length);
    }
    resultArr[index] = result;
    if (!Array.isArray(propertyVal) && item.config.getInputProp(name, 'default_prop_value') != propertyVal){
      item.config.setInputValue(name, 'default_prop_value', propertyVal);
    }
    item.config.setInputValue(name, prop, resultArr);

    // this.calculateAllInputs(item);

    this.cd.detectChanges();
  }

  private setWrongNumberToZero(value, skipNegativeCheck = false){
    let result:any = parseFloat(value);
    if ((!skipNegativeCheck && result < 0) || isNaN(result)){
      result = '0';
    }
    return result;
  }

  getInputProp(name, keyVal, index){
    let item = this._currentItem;
    // let setting = this.settings[name];
    // // let resultArr;
    // // return item.config.getInputProp(name, 'value')[index];
    // if (keyVal === 'value' && this.measurement.hasMeasurement(item, name)) {
    //   console.log('if item.config.getInputByName(name)', item.config.getInputByName(name));
    //   console.log('index', index);
    //   //current converted value
    //    let value = item.config.getInputProp(name, 'value');
    //    // let value = this.measurement.getMeasurementVal(item, item.config.getInputByName(name), name, index, true);
    //    console.log('value 123321123321', value);
    //   // if (Array.isArray(item.config.getInputProp(name, 'value'))){
    //   //   resultArr = item.config.getInputProp(name, 'value');
    //   //   resultArr[index] = value;
    //   // }
    //
    //   // if (!Array.isArray(resultArr)){
    //   //   let tmpResult = resultArr;
    //   //   resultArr = new Array(index);
    //   //   resultArr[index] = tmpResult;
    //   // }
    //   // console.log('if 3', resultArr.slice());
    //   let result = value;
    //
    //   if (result == null || result === 0) {
    //     return '0';
    //   } else {
    //     const isHasRightMeasurementLabel = (setting) ? this.isSettingHasMeasurement(name) : false;
    //     if (isHasRightMeasurementLabel) {
    //       const settingLabel = this.getSettingLabelMeasurement(setting);
    //       result = result.replace(settingLabel, '');
    //     }
    //     return result;
    //   }
    // }

    let inputProp = item.config.getInputProp(name, keyVal);
    if (Array.isArray(inputProp)){
      return inputProp[index];
    }
    return inputProp;
  }

  getSettingLabelMeasurement(setting){
    if (this.hasMeasurement && setting.value.hasOwnProperty('label')) {
      return this.measurement.getMeasurementLabelSymbol(this._currentItem, this._currentItem.config.getInputByName(setting.key));
    }
    return null;
  }


  canEditItem(){
    return !this.isViewMode;
  }

  getSetting(name){
    return this.settings[name]
  }

  getParamOptions(optionConfig){
    return optionConfig.options;
  }

  getParamOptionValue(option){
      if (typeof option == 'string') {
        return option;
      }
      if (option.hasOwnProperty('value')) {
        return option.value;
      }
      return option.label;
  }

  getParamOptionStyle = function (option) {
    return ((typeof option == 'string') ? '' : option.style);
  };

  getParamOptionLabel = function (option) {
    return ((typeof option == 'string') ? option : option.label);
  };


  setItemSettingsNames(){
    let inputs = this._currentItem.config.getInputs();
    this.vertexInputNames = [];
    for (let name in inputs){
      if (inputs.hasOwnProperty(name) && inputs[name].hasOwnProperty('per_vertex')){
        this.settings[name] = inputs[name];
        this.vertexInputNames.push(name);
      }
    }
  }

  closeModal(){
    this.bs.closeModal();
  }

  private initInputValues() {
    this.vertexInputNames.forEach((name)=>{
      let currentInputValue = this._currentItem.config.getInputProp(name, 'value');
      if (!Array.isArray(currentInputValue)){
        let value = this.measurement.getMeasurementVal(this._currentItem, this._currentItem.config.getInputByName(name), name, null, true);
        let resultArr = new Array(this.getPoints().length).fill(value, 0, this.getPoints().length);
        if (this._currentItem.config.getInputProp(name, 'default_prop_value') != currentInputValue){
          this._currentItem.config.setInputValue(name, 'default_prop_value', currentInputValue);
        }
        this._currentItem.config.setInputValue(name, 'value', resultArr);
      }
    });
  }

  private getMeasurementUnconvertedVal(item, name, prop, result) {
    if (this.measurement.hasMeasurement(item, name) && prop.toLowerCase() === 'value') {
      if (result.toString().indexOf(',') >= 0) {
        result = result.replace(/,/, '.');
      }

      result = this.measurement.getUnconvertedInputVal(item, item.config.getInputByName(name), result);

      if (isNaN(result) || result === '') {
        result = '0';
        return result;
      }
    }
    return result;
  }
}
